import { render, staticRenderFns } from "./DownloadRow.vue?vue&type=template&id=6b1560e5&"
import script from "./DownloadRow.vue?vue&type=script&lang=js&"
export * from "./DownloadRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports